import React,{useEffect, useState} from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { Container, Button, Row} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { getOrigenDetail, editOrigen, getOrigens } from '../../../actions/origensActions'
import FormOrigen from '../../admin/origens/FormOrigen'
import Swal from 'sweetalert2'

export default function OrigenEdit() {     
    const { t } = useTranslation()
    const {id} = useParams()
    const {origen, origens} = useSelector(state=>state.origens)
    const dispatch = useDispatch()

    const [formState, setFormState] = useState({})
    const {name, type, distances, idOrigen} = formState

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleEdit = async(e) => {
        e.preventDefault()

        dispatch(editOrigen(name, type, distances, idOrigen))
        Swal.fire({
            showConfirmButton: true,
            icon: 'success',
            text: t('origens.messageedit')
        })
        dispatch(getOrigens())
    }

    const handleCheckboxChange  = (e) => {
        setFormState({
            ...formState,
            [e.target.name]: e.target.checked
        })
    }

    useEffect(()=>{
        dispatch(getOrigenDetail(id))
        dispatch(getOrigens())
    }, [dispatch,id])

    useEffect(() => {
        if (origen) {
            setFormState({
                name: origen.name,
                type: origen.type,
                distances: origen.distances,
                idOrigen: origen._id
            })
        }
    }, [origen, dispatch, id])
  
    return (
        <Container className='cuerpo'>
            <Row className="text-left custom-card-header-list">
                <Row className="custom-card-buttom">
                    <Button className="btn btn-secondary mb-4 mx-auto" href={`/admin/origens`}>
                        <i className="fas fa-arrow-circle-left"></i> {t('origens.volver')}
                    </Button>
                </Row>
                <h1>{t('origens.name')}: <span className='text-uppercase'>{origen?.name}</span></h1>
                <FormOrigen submit={handleEdit} isNew={false} inputChange={handleInputChange} handleCheckbox={handleCheckboxChange} state={formState} origens={origens}></FormOrigen>
            </Row>
        </Container>
    )
}
